import { render } from "./CRM.vue?vue&type=template&id=ec96b69e"
import script from "./CRM.vue?vue&type=script&lang=js"
export * from "./CRM.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__